// Relative Path: src\js\_general.js

class General {
	constructor() {
		this.init();
	}

	init() {
		// this.checkOverflow();
	}

	checkOverflow() {
		const docWidth = document.documentElement.offsetWidth;

		document.querySelectorAll("*").forEach((el) => {
			if (el.offsetWidth > docWidth) {
				console.warn("Layout overflow detected:", el);
				// el.style.border = "1px solid #cbff03";
			}
		});
	}
}

export default General;
